<template>
  <div id="download " ref="cd">
    <div class="download-app">
      <b-container>
        <b-row class>
          <b-col md="6" sm="12" id="left-content" class="my-auto">
            <b-row class="row-text">
              <b-col md="10" sm="12" class="last-content">
                <p class="para">{{ paragraph }}</p>
              </b-col>
            </b-row>
            <b-row id="image-links" class="downloadimage-center" v-if="visibility">
              <b-col sm="7" md="6">
                <img
                  class="downloadImage"
                  alt="Google Play Image"
                  @click="googleplayLink()"
                  v-lazy="require(`@/assets/img/${filename.google}`)"
                />
              </b-col>
              <b-col sm="7" md="6">
                <img
                  class="downloadImage"
                  alt="Apple App Store Image"
                  @click="appstoreLink()"
                  v-lazy="require(`@/assets/img/${filename.apple}`)"
                />
              </b-col>
            </b-row>
            <div class="list" v-if="visibility">
              <b-row class="list-data">
                <b-col md="10" sm="12">
                  <ul id="download-list-content">
                    <li
                      class="list-content pt-2"
                      v-for="listdata in list"
                      :key="listdata"
                    >{{ listdata }}</li>
                  </ul>
                </b-col>
                <!--   <div  class="waypoint"
                v-waypoint="{ active: true, callback: scrollToPd, options: intersectionOptions }"></div>-->
              </b-row>
            </div>
          </b-col>
          <b-col md="6" sm="12" id="right-content">
            <img class="mobileImage" v-lazy="require(`@/assets/img/${sideImage}`)" alt="phoneImage" />
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "DownloadApp",
  props: [
    "heading",
    "list",
    "paragraph",
    "filename",
    "visibility",
    "sideImage",
  ],
  data() {
    return {
     
    };
  },
  methods: {
    googleplayLink() {
      window.open(
        "https://play.google.com/store/apps/details?id=com.ftcash.customer",
        "_blank"
      );
    },
    appstoreLink() {
      window.open("https://apps.apple.com/in/app/ftcash/id998463502", "_blank");
    },
  },
};
</script>

<style scoped>
#download-list-content {
  list-style-position: outside;
}

.mobileImage {
  width: 54%;
  /* height:95%; */
  margin-top: 1rem;
}
.list {
  padding-top: 2rem;
  width: 100%;
  text-align: justify;
}
.list-content,
.last-content {
  color: var(--mainBlueColor);
}
.last-content {
  padding-left: 1rem;
}
.downloadImage {
  border-radius: 10px !important;
  width: 100%;
  cursor: pointer;
}
.downloadimage-center {
  width: 75%;
  height: 50%;
  padding-top: 2rem;
  padding-left: 1rem;
}
.row-text {
  padding-top: 2rem;
  text-align: left;
  font-size: 1rem;
}
.para {
  text-align: justify;
  /* padding-top: 1rem; */
}
ul {
  list-style-position: outside;
  padding-left: 0;
}
.list-data {
  padding-left: 1rem;
}
/* Media Queries */
/* Tablet View */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  .downloadimage-center {
    width: 100%;
  }
  .row-text {
    padding-top: 2rem;
    text-align: left;
    width: 460px;
    font-size: 0.9rem;
  }
  .list {
    width: 425px;
  }
  .download-app-heading {
    display: none;
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .row-text {
    padding-top: 2rem;
    text-align: left;
    margin-left: 1rem;
    width: 550px;
    font-size: 0.9rem;
  }
  .list {
    margin-left: 2rem;
    width: 515px;
  }
  .downloadimage-center {
    width: 100%;
  }
}
/* Mobile View */
@media (min-width: 481px) and (max-width: 767px) {
  #left-content {
    /* order: 2; */
    padding-left: 15px !important;
  }
  #right-content {
    /* order: 1; */
    /* margin-bottom: 2rem;*/
    margin-top: 2rem;
  }
  .list {
    padding-top: 1.5rem;
    width: 90%;
    margin: 0 auto;
  }
  .list-content {
    font-size: 0.75rem;
    font-weight: 400;
  }
  .downloadImage {
    border-radius: 10px !important;
    margin-bottom: 0.5rem;
    width: 100%;
  }
  .downloadimage-center {
    margin: auto;
    padding: 2rem 0 0 0;
    height: 100%;
    width: 55%;
    justify-content: center;
  }
  .para {
    text-align: center;
    font-size: 0.75rem;
    margin-bottom: 0;
  }
  .row-text {
    padding-top: 0;
    text-align: left;
    font-size: 0.9rem;
  }
  .list-data {
    padding-left: 0;
  }
  .download-list-content {
    margin-bottom: 0;
    list-style-position: inside;
    text-align: center;
  }
  .download-app-heading {
    display: none;
  }
}
@media (max-width: 480px) {
  #left-content {
    /* order: 2; */
    padding-left: 15px !important;
  }
  #right-content {
    /* order: 1; */
    /* margin-bottom: 2rem;
    display: none; */
    margin-top: 2rem;
  }
  .list {
    padding-top: 1.5rem;
    width: 90%;
    margin: 0 15px;
  }
  .list-content {
    font-size: 0.75rem;
    font-weight: 400;
  }
  .downloadImage {
    border-radius: 10px !important;
    margin-bottom: 0.5rem;
    width: 80%;
  }
  .downloadimage-center {
    margin: auto;
    padding: 2rem 0 0 0;
    height: 100%;
    width: 55%;
    justify-content: center;
  }
  .para {
    text-align: center;
    margin-bottom: 0;
    font-size: 0.75rem;
  }
  .row-text {
    padding-top: 0;
    text-align: left;
    font-size: 0.9rem;
  }
  .list-data {
    padding-left: 0;
  }
  .download-list-content {
    margin-bottom: 0;
  }
  .download-app-heading {
    display: none;
  }
}
</style>
